import React from 'react';
import { motion } from 'framer-motion';
import { Download, Search, HeartPulse } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Download size={32} data-id="element-281" />,
    title: '1. Descargás la guía',
    desc: 'Tenés el PDF en tu celular listo para abrir incluso sin internet.'
  }, {
    icon: <Search size={32} data-id="element-282" />,
    title: '2. Identificás el riesgo',
    desc: 'Usás el Protocolo Semáforo ante cualquier síntoma extraño.'
  }, {
    icon: <HeartPulse size={32} data-id="element-283" />,
    title: '3. Actuás con precisión',
    desc: 'Seguís las instrucciones de estabilización y vas a la guardia con la información que el veterinario necesita.'
  }];
  return <section className="py-8 md:py-12 px-4 bg-neutral-950" data-id="element-284">
      <div className="container mx-auto max-w-5xl" data-id="element-285">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-286">
          <h2 className="text-3xl md:text-6xl font-display text-white mb-3" data-id="element-287">
            ¿Cómo funciona?
          </h2>
          <p className="text-lg md:text-xl text-neutral-400" data-id="element-288">
            Tres pasos simples para salvar una vida.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative" data-id="element-289">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-neutral-800 z-0" data-id="element-290" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-291">
              <div className="w-16 h-16 md:w-24 md:h-24 rounded-full bg-neutral-900 border-4 border-neutral-950 shadow-[0_0_0_2px_rgba(255,107,0,0.3)] flex items-center justify-center text-brand mb-4" data-id="element-292">
                {step.icon}
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-293">
                {step.title}
              </h3>
              <p className="text-neutral-400 text-base md:text-lg leading-relaxed max-w-xs" data-id="element-294">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}